import styled from "styled-components";

// $variant: "purple" (default) or "lime"
const StatusChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: ${(props) => (props.$variant === "lime" ? "var(--limeSurface)" : "var(--purpleSurface)")};
  color: ${(props) => (props.$variant === "lime" ? "var(--lime)" : "var(--purpleText)")};
  font-family: var(--fontMono);
  font-size: 10px;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  white-space: nowrap;
`;

export default StatusChip;
